export const defaultValues = {
  renta_liquida: '',
  sueldo_variable: '',
  boletas_value: '',
  arriendos_value: '',
  ahorros_value: '',
  ahorromensual_value: '',
  credito_hipotecario: '',
  credito_consumo: '',
  cuotas_restantes: '',
  firstname: '',
  email: '',
  phone: '',
}

export const inputs = [
  {
    type: 'text',
    name: 'renta_liquida',
    label: '¿Cuál es tu renta líquida aproximada?',
    placeholder: '$ 0.00',
    isRequired: false,
    className: 'col-span-2',
  },
  {
    type: 'text',
    name: 'sueldo_variable',
    label: 'Sueldo variable (70%)',
    placeholder: '$ 0.00',
    isRequired: false,
    className: 'col-span-2',
  },
  {
    type: 'text',
    name: 'boletas_value',
    label: 'Boletas (70%)',
    placeholder: '$ 0.00',
    isRequired: false,
    className: 'col-span-2',
  },
  {
    type: 'text',
    name: 'arriendos_value',
    label: 'Arriendos (50%)',
    placeholder: '$ 0.00',
    isRequired: false,
    className: 'col-span-2',
  },
  {
    type: 'text',
    name: 'ahorros_value',
    label: 'Ahorros al presente',
    placeholder: '$ 0.00',
    isRequired: false,
    className: 'col-span-2',
  },
  {
    type: 'text',
    name: 'ahorromensual_value',
    label: 'Capacidad de ahorro mensual',
    placeholder: '$ 0.00',
    isRequired: false,
    className: 'col-span-2',
  },
  {
    type: 'text',
    name: 'credito_hipotecario',
    label: 'Cuota crédito hipotecario',
    placeholder: '$ 0.00',
    isRequired: false,
    className: 'col-span-2',
  },
  {
    type: 'text',
    name: 'credito_consumo',
    label: 'Cuota crédito al consumo',
    placeholder: '$ 0.00',
    isRequired: false,
    className: 'col-span-2',
  },
  {
    type: 'text',
    name: 'cuotas_restantes',
    label: 'Cuotas restantes',
    placeholder: '0',
    isRequired: false,
    className: 'col-span-2',
  },
  {
    type: 'text',
    name: 'firstname',
    label: 'Escribe tu nombre y apellido',
    placeholder: 'Usuario',
    isRequired: true,
    className: 'col-span-2',
  },
  {
    type: 'email',
    name: 'email',
    label: 'Escribe tu correo electrónico',
    placeholder: 'usuario@correo.com',
    isRequired: true,
    className: 'col-span-2',
  },
  {
    type: 'number',
    name: 'phone',
    label: 'Teléfono de contacto',
    placeholder: '56 5555 555 555',
    isRequired: true,
    className: 'col-span-2',
  },
]
